import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import { getSelectedImages, getCurrentFolderImages, createFilePathObject } from 'MyAccount/AssetManager/ImageManager/selectors';

@connect(
  state => {
    const selectedImages = getSelectedImages(state);
    const selected = _.keys(selectedImages);
    let image = {};
    if (selected.length === 1) {
      const imagePathObj = createFilePathObject(_.keys(selectedImages)[0]);
      const images = getCurrentFolderImages(state, {
        resourceType: 'Images',
        currentFolder: state.images.Images.selectedFolder,
      });
      const index = _.findIndex(images, (image) => image.name === imagePathObj.fileName);
      image = images[index];
    }
    return ({
      selectedImages,
      image,
    });
  }
)
export default class ButtonSection extends Component {

  onContinue = () => {
    const { image, onContinue } = this.props;
    onContinue(image.url);
  };

  render() {
    const {
      styles,
      selectedImages,
      description,
      inputValid,
    } = this.props;

    const count = _.size(selectedImages);
    return (
      <div style={styles.buttonsSection}>
        {description ? `${count} selected` : ''}
        <RaisedButton
          disabled={inputValid ? !inputValid : count !== 1}
          style={{marginLeft: 20, ...styles.mainButton}}
          primary
          onClick={this.onContinue}
          label="continue"
        />
      </div>
    );
  }
}
